import React, { PureComponent } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import { FieldWrapper, ErrorBoundary } from 'common/components';
import { ContractList } from 'containers';

export class Contracts extends PureComponent {
  static displayName = 'Contracts';

  static propTypes = {
    showMapFlag: bool.isRequired,
  };

  render() {
    const { showMapFlag } = this.props;

    return (
      <ErrorBoundary>
        <FieldWrapper
          showStorages
          showFields
          showMapFlag={showMapFlag}
          ignoreMapUpdate
        >
          <ContractList />
        </FieldWrapper>
      </ErrorBoundary>
    );
  }
}

const mapState = ({ field: { showMapFlag } }) => ({ showMapFlag });

export default connect(mapState)(Contracts);



// WEBPACK FOOTER //
// ./src/pages/Contract/index.js